import { getEnv } from '../../helpers/EnvHelper';
import { DefaultButton, DirectionalHint, PrimaryButton, TooltipHost } from "@fluentui/react";
import React, { useEffect, useState, useContext ,useMemo} from "react";
import ReportIcon from "../../components/SVGComponents/ReportIcon";
import AnnotationContext from "../../context/annotation/AnnotationContext";
import AnnotationBox from "./components/AnnotationBox/AnnotationBox";
import AddPathologyIcon from "../../components/SVGComponents/AddPathologyIcon";
import SelectedAnnotationsList from "./components/SelectedAnnotationList/SelectedAnnotationList";
import "./styles/styles.css";
import ViewportContext from "../../context/studyviewer/ViewportContext";
import { useTranslation } from "react-i18next";
import {
  commonAllowedRolesAccess,
  NONXRAYMODALITIES,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  showPathologyForModalities,
  USERTYPES,
} from "../../constants/Constants";
import studyviewerContext from "../../context/studyviewer/StudyviewerContext";
import OutlineButton from "../StudyViewer/Components/Tools/ToolComponents/OutlineButton";
import HeatMapButton from "../StudyViewer/Components/Tools/ToolComponents/HeatMapButton";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import { resizeViewport } from "../StudyViewer/helpers/CornerstoneViewportService";
import { eventBus } from "./helper/initialData";
import ThumbnailContext from "../../context/studyviewer/ThumbnailContext";
import userContext from "../../context/users/UserContext";
import ArchivedPathologyIcon from "../../components/SVGComponents/ArchivedPathologyIcon";
import ArchivedPathologies from "./components/ArchivedPathologies/ArchivedPathologies";
import NonEditablePathologiesList from "./components/SelectedAnnotationList/NonEditablePathologyList";
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../context/theme/ThemeContext";
import AddClassificationPathologyIcon from "../../components/SVGComponents/Tools/AddClassificationPathologyIcon";
import ClassificationBox from "./components/ClassificationBox/ClassificationBox";
import InfoIcon from "../../components/SVGComponents/InfoIcon";
import { toolTipStyles } from "../StudyViewer/styles/styles";
import { isMobile } from "react-device-detect";
//added for quality flag
import useImageQuality from "../../hooks/useImageQuality";
import QualityIcon from "../../components/QualityIcon/QualityIcon";



const Annotations = (props) => {
  const { studyData, studyModality, priorStudyData, parentChildReportsObj, cxrVersion, boneEnabled, isLandscape,showAiResult, showSavedReport,studyResponseData,
    setReportMenu, setSeriesMenu, reportMenu } =
    useContext(studyviewerContext);
  const { roles, authenticated, loadByUsername, username, qcReviewer, isActiveData, enableLlmReport, privilegedFirmDoctor } =
    useContext(userContext);
  let [showInfo1, setShowInfo1] = useState(false);
  const [t] = useTranslation();
  const {
    allAnnotations,
    addedAnnotation,
    addedChildAnnotation,
    addOrRemoveAnnotation,
    submitSelectedOptions,
    checkForOptionSubOption,
    pathologiesLoading,
    childPathologyPresentObj,
    classificationStateStore,
    childClassificationState
  } = useContext(AnnotationContext);
  const {
    disableAddPathology,
    setDisableAddPathology,
    archivedPathology,
    isChildStudyActive,
  } = useContext(ViewportContext);
  const {
    enableReportRegenerate,
    setEnableReportRegenerate,
    isClientReportExist,
    isChildStudyReportState,
    isWordFilePath,
    activeTab,
    disableEditReport
  } = useContext(studyReportContext);

  const { getAlterColor, themeName, getThemeColor } = useContext(themeContext);

  const { activeThumbnailIndex, activeStudyId } = useContext(ThumbnailContext);

  // The "study not supported by AI" note is a statement about the study's MODALITY,
  // so it has to be derived from the modality itself. It must NOT be derived from
  // showPriorStudyTopBar: that flag is also false while the study structure is still
  // loading, which made every study - including AI-processed DX/CR chest X-rays -
  // render as unsupported during the load window.
  // The !!modality guards keep "unsupported" separate from "not known yet": with no
  // modality resolved we render nothing instead of asserting non-support.
  // !cxrVersion keeps the note out of the Analyzer flow, which owns the
  // AI TOOLS / CLASSIFICATIONS panel and where the note is never true.
  const activeChildStudyModality = parentChildReportsObj?.[activeStudyId]?.modality;
  const showNonXrayNoteForParentStudy =
    !cxrVersion &&
    !!studyModality &&
    !SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(studyModality);
  const showNonXrayNoteForChildStudy =
    !cxrVersion &&
    !!activeChildStudyModality &&
    !NONXRAYMODALITIES.includes(activeChildStudyModality);

  // The AI/pathology panel now stays mounted for the whole priors session as soon as
  // ANY study in the group is an AI-eligible modality (see Viewer.jsx) - that is what
  // removed the panel's jumping/flicker. As a result "the panel is rendered" no longer
  // implies "the active study is an X-ray". Regenerate Report acts on the ACTIVE
  // study's annotations, so it has to follow the active study's own modality; without
  // this it stayed visible right next to the "not supported by AI" note whenever a
  // non-X-ray prior (MR/CT/US/...) was selected.
  // parentChildReportsObj is keyed by every study id in the group (parent included),
  // so it resolves the active study's modality; studyModality (the parent's) is the
  // fallback for the window before that map has committed.
  // cxrVersion is only set on chest X-ray studies, so it stands in for "AI supported"
  // in the Analyzer flow, matching the note logic above.
  const activeStudyModality = activeChildStudyModality || studyModality;
  const isAiSupportedActiveStudy =
    !!cxrVersion || showPathologyForModalities.includes(activeStudyModality);
  //const [enableReportRegenerate, setEnableReportRegenerate] = useState(false);
  const [showConfigureMenu, setShowConfigureMenu] = useState(false);
  const [showArchivedPathology, setShowArchivedPathology] = useState(false);
  const [count, setCount] = useState(addedAnnotation.length);
   const { priorStudyResponseData } = useContext(studyviewerContext);
  
  const activeDataForQuality = priorStudyResponseData?.studyDtoList?.length > 0
    ? priorStudyResponseData
    : { studyDtoList: [studyResponseData, ...(priorStudyData?.map(p => p.studyData || p) || [])].filter(Boolean) };

//For quality model 
  const { studyErrors } = useImageQuality(activeDataForQuality);

  useEffect(() => {
    // if(allAnnotations != [])
    // console.log(allAnnotations);
  }, [allAnnotations]);

  const updatedStylesEnable = {
    root: {
      height: "28px",
      
    },
    rootHovered: {
    
    },
  };


  useEffect(() => {
    if (addedAnnotation.length != count) {
      // console.log("Enabling report regenerate button");
      //setEnableReportRegenerate(true);
    }
    setCount(addedAnnotation.length);
  }, [addedAnnotation]);

  const buttonStyle = {
    fontWeight: "400",
  };

  const getAbbreviated = (str) => {
    var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    var acronym = matches.join(""); // JSON
    if (acronym.length > 2) {
      acronym = acronym.slice(0, 2);
    }
    return acronym;
  };

  function hexToRgb(hex, check) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result != null) {
      var r = parseInt(result[1], 16);
      var g = parseInt(result[2], 16);
      var b = parseInt(result[3], 16);
    }
    if (check) {
      return "rgb(" + r + "," + g + "," + b + ",0.5)";
    }
    return "rgb(" + r + "," + g + "," + b + ")";
  }

  const onHoverIn = () => {
    if (!isChildStudyActive) {
      setShowArchivedPathology(false);
      setShowConfigureMenu(true);
    }
  };
  const onHoverOut = () => {
    setShowConfigureMenu(false);
  };

  const onHoverInArchivePathology = () => {
    setShowArchivedPathology(true);
  };
  const onHoverOutArchivePathology = () => {
    setShowArchivedPathology(false);
  };

  const regenerateButtonClick = () => {
    if (!isChildStudyActive) {
      let res = submitSelectedOptions();
      if (res != false) {
        setEnableReportRegenerate(false);
        setReportMenu(true);
        setSeriesMenu(false);
        setTimeout(() => {
          resizeViewport();
        }, 500);
      }
    }
  };

  const checkForRegenerateButton = () => {
    if (isWordFilePath) {
      return false;
    }
    if (disableEditReport){
      return false;
    }
    // Non-X-ray active study (typically a prior selected in the priors viewer):
    // there is no AI report to regenerate, so the button must not be offered.
    if (!isAiSupportedActiveStudy) {
      return false;
    }
    return roles.length > 0 &&
    (roles.includes(USERTYPES.RADIOLOGIST) || (roles.includes(USERTYPES.FIRMADMIN) && !disableEditReport)) && 
    isClientReportExist != null &&
    !isClientReportExist && !enableLlmReport ;
  }

  const checkForAnyNonAIPathology = (pathologies) => {
    let flag = false;
    let count = 0;
    pathologies?.map((annotation, index) => {
      if (
        annotation.is_locked == true ||
        annotation.is_annotated == true ||
        annotation.is_locked_check == true ||
        annotation.is_annotated_check == true
      ) {
        count++;
        flag = true;
      }
    });
    return { show: flag, count: count };
  };

  // Role-gated only - deliberately no modality check here. The AI TOOLS section
  // (label + Outline/HeatMap buttons) should still render for a non-xray study
  // (e.g. an MR parent); OutlineButton/HeatMapButton already render themselves
  // disabled when the active viewport has no outline/heatmap image data, so
  // gating this whole section on modality would hide the buttons entirely
  // instead of showing them disabled.
  const checkForAIToolsExist = () => {
    if (
      ((roles[0] !== USERTYPES.FIRMDOCTOR && roles[0] !== USERTYPES.FIRMTECHNICIAN) || showAiResult || privilegedFirmDoctor) &&
      (roles[0] !== USERTYPES.SUPERVISOR ||
        (roles[0] === USERTYPES.SUPERVISOR && qcReviewer == 1))
    ) {
      return true;
    }
    return false;
  };

  return (
       <div
  className="annotation-container"
  style={{ display: "flex",alignItems: "center",justifyContent: "space-between",paddingRight: "10px",width: "100%",height: "100%"}}
>
      <div style={{display:"flex",justifyContent:"flex-start", ...(isLandscape ? {width:"calc(100% - 170px)"} : {flex:1, minWidth:0, paddingRight:"40px", boxSizing:"border-box"}), height:"100%",alignItems:"center"}}>
      {(checkForAIToolsExist())  && 
             <div
              style={{
                display: "flex",
                cursor: "pointer",
               // width: "100%",
                justifyContent: "space-evenly",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <div className="info-text" style={{ display: "flex", justifyContent: "center" }}>
                {t("annotations.ai-tools")}
              </div>
              <div
                style={{
                  display: "flex",
                  cursor: "pointer",
                  // width: "100%",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  width:"100%",
                  height: "47px",
                 
                }}
              >
               <div style={{ 
                 background: themeName === "light" ? "#EEF3FF" : "unset",
                  }}
                className="annotation-heatmap-container"  
                  >
                {/* Always mount when there's study data - OutlineButton/HeatMapButton
                    already render themselves in a disabled, not-allowed-cursor state
                    when the active viewport has no outline/heatmap image data (e.g. an
                    AI-unsupported modality like MR), so gating on modality here would
                    just hide the buttons instead of showing them disabled. */}
                {studyData && (
                    <OutlineButton
                      priors={props.priors}
                      outlineData={
                        props.priors
                          ? priorStudyData[0]?.outlines
                          : studyData?.outlineStacks
                      }
                    />
                  )}
                {studyData && (
                    <HeatMapButton
                      priors={props.priors}
                      heatmapData={
                        props.priors
                          ? priorStudyData[0]?.heatmaps
                          : studyData?.heatmapStacks
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          }
      <div className="viewer-annotation-seperator"></div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "90%",
          marginLeft: "0px",
          height: "100%",
        }}
      >
       
        {/* <PrimaryButton
          text="+"
          onClick={() => {
            if (showInfo1) {
              setShowInfo1(false);
            } else {
              setShowInfo1(true);
            }
          }}
          className="add-annotation-button"
          style={{
            backgroundColor: !showInfo1 ? "rgba(218, 218, 218, 0.54)" : "rgb(0, 120, 212)",
            marginRight: "30px",
            marginLeft: "0px",
            width:"26.67px",
            height:"26.67px"
          }}
        /> */}
        {/*<div
          style={{
            cursor: !disableAddPathology ? "pointer" : "not-allowed",   
          }}
          className="annotation-add-icon"
          onClick={() => {
            if (showInfo1 && !disableAddPathology) {
              setShowInfo1(false);
            } else if (!disableAddPathology) {
              setShowInfo1(true);
            }
          }}
        >
          <AddPathologyIcon active={showInfo1} />
          <AnnotationBox
          show={showInfo1}
          onClickOutside={() => {
            setShowInfo1(false);
          }}
          setShowInfo1={setShowInfo1}
        />
        </div>*/}
        {/* {(!(
          studyData.outlineStacks[activeThumbnailIndex]?.imageIds[0] === null ||
          studyData.outlineStacks[activeThumbnailIndex]?.imageIds[0] === ""
        ) && checkForAIToolsExist()) && <div className="border-seperator-annotation"></div>} */}
        {!isChildStudyActive && cxrVersion && (
          <>
          <div style={{display: "flex", justifyContent: "space-evenly", alignItems: "start", height: "100%", width: "330px", flexDirection: "column"}}>
            <div className="info-text" style={{height: "15px", marginLeft: "10px", display: "flex"}}>
                <span style={{marginRight: "8px"}}>{t("annotations.classification")}</span>
                <CustomToolTipHost
                  styles={toolTipStyles}
                  content={t("annotations.classification-disclaimer")}
                  id={"classification-disclaimer"}
                  directionalHint={DirectionalHint.rightCenter}
                >
                  <InfoIcon /> 
                </CustomToolTipHost>
            </div>
            <div
              style={{
                marginLeft: "8px",
                width: "310px",
                height: "50px",
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {classificationStateStore?.map((classification, index) => {
                if(classification?.classificationName === "Bones" && !boneEnabled) return;
                return <ClassificationBox classification={classification} key={index}/>;
              })}
            </div>
          </div>
          <div className="viewer-annotation-seperator"></div>
          </>
        )}
        {isChildStudyActive && cxrVersion && (
          <>
          <div style={{display: "flex", justifyContent: "space-evenly", alignItems: "start", height: "100%", width: "330px", flexDirection: "column"}}>
            <div className="info-text" style={{height: "15px", marginLeft: "10px", display: "flex"}}>
                <span style={{marginRight: "8px"}}>{t("annotations.classification")}</span>
                <CustomToolTipHost
                  styles={toolTipStyles}
                  content={t("annotations.classification-disclaimer")}
                  id={"classification-disclaimer"}
                  directionalHint={DirectionalHint.rightCenter}
                >
                  <InfoIcon /> 
                </CustomToolTipHost>
            </div>
            <div
              style={{
                marginLeft: "8px",
                width: "310px",
                height: "50px",
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {childClassificationState?.map((classification, index) => {
                if(classification?.classificationName === "Bones" && !boneEnabled) return;
                if(classification?.classificationName?.toLowerCase() === "all") return;
                return <ClassificationBox classification={classification} key={index}/>;
              })}
            </div>
          </div>
          <div className="viewer-annotation-seperator"></div>
          </>
        )}

        {addedAnnotation.length > 0 && !isChildStudyReportState ? (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "start",
                flexDirection: "column",
                ...(isLandscape
                  ? { width: `${cxrVersion ? 'calc(100% - 320px)' : '100%'}` }
                  : { flex: 1, minWidth: 0, width: cxrVersion ? 'calc(100% - 320px)' : undefined }),
                height: "100%",
                justifyContent: "space-evenly",
              }}
            >
              <div
                style={{
                  visibility: addedAnnotation.length > 0 ? "visible" : "hidden",
                  marginLeft: "10px",
                }}
                className="info-text"
              >
                {t("annotations.smart-tags")}
              </div>
              <SelectedAnnotationsList />
            </div>
          </>
        ) : (
          !isChildStudyReportState && (
            <div
              style={{
                display: "flex",
                alignItems: "start",
                flexDirection: "column",
                width: `${cxrVersion ? 'calc(100% - 320px)' : 'calc(100% - 170px)'}`,
                marginLeft: "26px",
              }}
            >
              {showNonXrayNoteForParentStudy ? (
                <span
                  style={{ color: getAlterColor("#9A9A9A", "") }}
                  className="empty-added-pathology-text"
                >
                  {t("annotations.non-xray-study")}
                </span>
              ) : (
                roles.length > 0 &&
                (roles.includes(USERTYPES.RADIOLOGIST) || (roles.includes(USERTYPES.FIRMADMIN) && !disableEditReport)) &&
                isClientReportExist != null &&
                !isClientReportExist && (
                  <span
                    style={{ color: getAlterColor("#9A9A9A", "") }}
                    className="empty-added-pathology-text"
                  >
                    {pathologiesLoading
                      ? `${t("string-literals.loading")}...`
                      : t("annotations.mark-or-add-annotation")}
                  </span>
                )
              )}
            </div>
          )
        )}

        {addedChildAnnotation[activeStudyId]?.length > 0 &&
        isChildStudyReportState &&
        childPathologyPresentObj[activeStudyId] ? (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "start",
                flexDirection: "column",
                ...(isLandscape ? { width: "100%" } : { flex: 1, minWidth: 0 }),
                height: "100%",
                justifyContent: "space-evenly",
              }}
            >
              <div
                style={{
                  visibility:
                    addedChildAnnotation[activeStudyId]?.length > 0
                      ? "visible"
                      : "hidden",
                  marginLeft: "10px",
                }}
                className="info-text"
              >
                {t("annotations.smart-tags")}
              </div>
              <NonEditablePathologiesList />
            </div>
          </>
        ) : (
          isChildStudyReportState && (
            <div
              style={{
                display: "flex",
                alignItems: "start",
                flexDirection: "column",
                width: "100%",
                marginLeft: "26px",
              }}
            >
              {showNonXrayNoteForChildStudy ? (
                <span
                  style={{ color: getAlterColor("#9A9A9A", "") }}
                  className="empty-added-pathology-text"
                >
                  {t("annotations.non-xray-study")}
                </span>
              ) : (
                roles.length > 0 &&
                (roles.includes(USERTYPES.RADIOLOGIST) || (roles.includes(USERTYPES.FIRMADMIN) && !disableEditReport)) &&
                isClientReportExist != null &&
                !isClientReportExist && (
                  <span
                    style={{ color: getAlterColor("#9A9A9A", "") }}
                    className="empty-added-pathology-text"
                  >
                    {pathologiesLoading
                      ? `${t("string-literals.loading")}...`
                      : t("annotations.no-annotation-present")}
                  </span>
                )
              )}
            </div>
          )
        )}
      </div>
      </div>
      {!isChildStudyReportState &&<div style={{ display: "flex", alignItems: "center" }}>
         {/* added for quality flag */}
          {studyErrors.length > 0 && (
            <QualityIcon errors={studyErrors.map(e => e.class ? `${e.class} - ${e.message}` : e.message)}  style={{ zoom: 1.5 }}  />

          )}
        {(checkForRegenerateButton() && isActiveData) && (
            <div className="annotation-buttons">
              {/* <DefaultButton iconProps={ReportIcon} text="Report" disabled/> */}
              {(!isMobile || isLandscape) &&
                <div
                onMouseEnter={onHoverIn}
                onMouseLeave={onHoverOut}
                style={{
                  background:
                    !enableReportRegenerate || isChildStudyActive
                      ? "transparent"
                      : "#2F80ED",
                  // height:
                  //   getEnv("REACT_APP_HYBRID_MODE") == "true"
                  //     ? "32px"
                  //     : "21px",
                  color: themeName != "light" ? "white" : "rgb(41 41 41)",
                  border: !enableReportRegenerate
                    ? themeName != "light"
                      ? "1px solid rgb(195, 196, 205)"
                      : "1px solid rgb(41 41 41)"
                    : "1px solid transparent",
                }}
                className="report-button"
                onClick={() => regenerateButtonClick()}
              >
                <span
                  style={{
                    color: !enableReportRegenerate
                      ? getThemeColor("primary-color")
                      : "white",
                  }}
                >
                  {t("studyviewer.regenerate-report")}
                </span>
              
              </div>
              } 
            </div>
          )}
        </div>
      }
    </div>
  );
};

export default Annotations;
